"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var FilterIcon_1 = __importDefault(require("mdi-react/FilterIcon"));
var MoreVertIcon_1 = __importDefault(require("mdi-react/MoreVertIcon"));
var SettingsIcon_1 = __importDefault(require("mdi-react/SettingsIcon"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var CircularProgress_1 = require("../CircularProgress");
var Grid_1 = require("../Grid");
var IconButton_1 = require("../IconButton");
var Popover_1 = require("../Popover");
var Select_1 = require("../Select");
var styles_1 = require("../styles");
var TablePagination_1 = require("../TablePagination");
var TextField_1 = require("../TextField");
var Toolbar_1 = require("../Toolbar");
var Tooltip_1 = require("../Tooltip");
var Typography_1 = require("../Typography");
var DataGridPaginationActions_1 = __importDefault(require("./DataGridPaginationActions"));
var testIdPrefix = 'DataGrid-DataGridHeader-';
var DataGridHeader = function (props) {
    var _a;
    var t = props.t, selected = props.selected, selectedOptions = props.selectedOptions, classes = props.classes, title = props.title, subTitle = props.subTitle, activeFiltersCount = props.activeFiltersCount, count = props.count, rowsPerPage = props.rowsPerPage, rowsPerPageOptions = props.rowsPerPageOptions, page = props.page, handleChangePage = props.handleChangePage, handleChangeRowsPerPage = props.handleChangeRowsPerPage, dropdownHandler = props.dropdownHandler, settingsHandler = props.settingsHandler, filterHandler = props.filterHandler, downloadingCaption = props.downloadingCaption, parentTestIdPrefix = props.parentTestIdPrefix, theme = props.theme, usePageSelectPopover = props.usePageSelectPopover;
    var _b = (0, react_1.useState)(false), showPageSelection = _b[0], setShowPageSelection = _b[1];
    var _c = (0, react_1.useState)(page + 1), inputPage = _c[0], setInputPage = _c[1];
    var displayedRowsLabel = (0, react_1.useRef)(null);
    var numSelected = selected.length;
    var totalPages = Math.ceil(count / rowsPerPage);
    var openPageSelect = function () { return setShowPageSelection(true); };
    var closePageSelect = function () { return setShowPageSelection(false); };
    var handleTextChangePage = function (event) { return setInputPage(event.target.value); };
    var submitPageChange = function (event) {
        // This is because this is used by a submit handler
        if (event) {
            event.preventDefault();
        }
        var chosenPage = inputPage;
        // Page out of range handler
        if (!inputPage || inputPage < 1) {
            chosenPage = 1;
        }
        else if (inputPage > totalPages) {
            chosenPage = totalPages;
        }
        if (chosenPage - 1 !== page) {
            handleChangePage(null, chosenPage - 1);
        }
        closePageSelect();
        setInputPage(chosenPage);
        // This is because this is used by a submit handler
        return false;
    };
    var dropdownButton = function () { return (react_1.default.createElement(Tooltip_1.Tooltip, { title: t('dt-listOptions') },
        react_1.default.createElement(IconButton_1.IconButton, { onClick: dropdownHandler, "data-testid": "".concat(parentTestIdPrefix).concat(testIdPrefix, "listOptionsButton"), color: "inherit", "aria-label": t('dt-listOptions') },
            react_1.default.createElement(MoreVertIcon_1.default, null)))); };
    var settingsButton = function () { return (react_1.default.createElement(Tooltip_1.Tooltip, { title: t('dt-settings') },
        react_1.default.createElement(IconButton_1.IconButton, { onClick: settingsHandler, color: "inherit", "aria-label": t('dt-settings') },
            react_1.default.createElement(SettingsIcon_1.default, null)))); };
    var renderActionButtons = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            settingsHandler && settingsButton(),
            dropdownHandler && dropdownButton()));
    };
    var renderFilterButton = function () { return (react_1.default.createElement("div", { className: classes.filterButton },
        react_1.default.createElement(Tooltip_1.Tooltip, { title: t('dt-filterList') },
            react_1.default.createElement(IconButton_1.IconButton, { onClick: filterHandler, color: "inherit", "aria-label": t('dt-filterList'), "data-testid": "".concat(parentTestIdPrefix).concat(testIdPrefix, "filterButton") },
                react_1.default.createElement(FilterIcon_1.default, null))),
        react_1.default.createElement(Typography_1.Typography, { variant: "body2", color: "inherit" }, "(".concat(activeFiltersCount, ") ").concat(t('active'))))); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.root },
            react_1.default.createElement(Toolbar_1.Toolbar, { className: (0, clsx_1.default)((_a = {},
                    _a[classes.highlight] = numSelected > 0,
                    _a)), classes: {
                    root: classes.toolbarRoot,
                } },
                react_1.default.createElement("div", { className: classes.title }, numSelected > 0 ? (react_1.default.createElement(Typography_1.Typography, { color: "inherit", variant: "subtitle1" }, numSelected + ' ' + t('dt-selected'))) : (react_1.default.createElement(Typography_1.Typography, { color: "inherit", variant: "h6", id: "tableTitle" }, title))),
                react_1.default.createElement("div", { className: classes.actions },
                    react_1.default.createElement(CircularProgress_1.CircularProgress, { color: "inherit", size: 24, className: (0, clsx_1.default)(classes.verticallyCentered, !downloadingCaption && classes.hide) }),
                    react_1.default.createElement(Typography_1.Typography, { color: "inherit", variant: "body2", className: (0, clsx_1.default)(classes.verticallyCentered, !downloadingCaption && classes.hide) }, downloadingCaption),
                    numSelected > 0 ? selectedOptions : renderActionButtons()))),
        react_1.default.createElement("div", { className: classes.header },
            react_1.default.createElement("div", null, renderFilterButton()),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Typography_1.Typography, { className: classes.subTitle, variant: "caption", color: "inherit" }, subTitle),
                react_1.default.createElement(TablePagination_1.TablePagination, { component: "div", classes: {
                        toolbar: classes.paginationToolbar,
                        select: classes.select,
                        selectIcon: classes.selectIcon,
                        input: classes.input,
                    }, 
                    // eslint-disable-next-line no-undef
                    count: count || data.length, rowsPerPage: rowsPerPage, labelRowsPerPage: t('dt-resultsPerPage'), labelDisplayedRows: usePageSelectPopover
                        ? function () { return (react_1.default.createElement(Tooltip_1.Tooltip, { title: "".concat(count, " ").concat(t('dt-results')) },
                            react_1.default.createElement("span", { className: classes.labelDisplayedRows, onClick: openPageSelect, ref: displayedRowsLabel },
                                page + 1,
                                " ",
                                t('dt-of'),
                                " ",
                                totalPages))); }
                        : undefined, page: page, backIconButtonProps: {
                        'aria-label': t('dt-previousPage'),
                    }, nextIconButtonProps: {
                        'aria-label': t('dt-nextPage'),
                    }, rowsPerPageOptions: rowsPerPageOptions, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage, ActionsComponent: function (props) { return (react_1.default.createElement(DataGridPaginationActions_1.default, __assign({ t: t }, props))); }, SelectProps: {
                        MenuProps: Select_1.MenuProps,
                        SelectDisplayProps: {
                            'data-testid': "".concat(parentTestIdPrefix).concat(testIdPrefix, "resultsPerPage"),
                        },
                        inputProps: {
                            'data-testid': "".concat(parentTestIdPrefix).concat(testIdPrefix, "resultsPerPage-value"),
                        },
                    } }))),
        usePageSelectPopover ? (react_1.default.createElement(Popover_1.Popover, { open: showPageSelection, onClose: submitPageChange, anchorEl: displayedRowsLabel.current, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, classes: {
                paper: classes.pageSelectionPaper,
            } },
            react_1.default.createElement(Grid_1.Grid, { container: true, justifyContent: "center", alignItems: "center", spacing: theme.spacing(1) },
                react_1.default.createElement(Grid_1.Grid, { item: true },
                    react_1.default.createElement("form", { onSubmit: submitPageChange },
                        react_1.default.createElement(TextField_1.TextField, { value: inputPage, onChange: handleTextChangePage, type: "number", margin: "dense", inputProps: {
                                min: 1,
                                max: totalPages,
                            } }))),
                react_1.default.createElement(Grid_1.Grid, { item: true },
                    t('dt-of'),
                    " ",
                    totalPages)))) : null));
};
DataGridHeader.propTypes = {
    activeFiltersCount: prop_types_1.default.number,
    t: prop_types_1.default.func.isRequired,
    theme: prop_types_1.default.object.isRequired,
    classes: prop_types_1.default.object.isRequired,
    selected: prop_types_1.default.array.isRequired,
    selectedOptions: prop_types_1.default.node.isRequired,
    dropdownHandler: prop_types_1.default.func,
    settingsHandler: prop_types_1.default.func,
    title: prop_types_1.default.string,
    subTitle: prop_types_1.default.string,
    downloadingCaption: prop_types_1.default.string,
    parentTestIdPrefix: prop_types_1.default.string,
    count: prop_types_1.default.number,
    rowsPerPage: prop_types_1.default.number,
    rowsPerPageOptions: prop_types_1.default.arrayOf(prop_types_1.default.number),
    page: prop_types_1.default.number,
    handleChangePage: prop_types_1.default.func,
    handleChangeRowsPerPage: prop_types_1.default.func,
    filterHandler: prop_types_1.default.func,
    usePageSelectPopover: prop_types_1.default.bool,
};
DataGridHeader.defaultProps = {
    usePageSelectPopover: true,
};
var styles = function (theme) { return ({
    root: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        position: 'relative',
    },
    header: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: theme.spacing(1.5),
        position: 'relative',
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        boxSizing: 'border-box',
        '& > div': {
            display: 'flex',
            alignItems: 'center',
        },
        borderBottom: 'solid 1px',
        borderBottomColor: theme.palette.grey[900],
    },
    toolbarRoot: {
        padding: "0 ".concat(theme.spacing(1.5), "px"),
        minHeight: theme.spacing(6),
    },
    filterButton: {
        display: 'flex',
        alignItems: 'center',
    },
    paginationToolbar: {
        color: theme.palette.primary.contrastText,
        minHeight: theme.spacing(6),
        height: theme.spacing(6),
    },
    highlight: theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: (0, styles_1.lighten)(theme.palette.secondary.light, 0.85),
        }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
        },
    actions: {
        flex: '1 1 100%',
        display: 'flex',
        justifyContent: 'flex-end',
        '& > *': {
            marginLeft: theme.spacing(1),
        },
    },
    title: {
        flex: '1 1 100%',
    },
    verticallyCentered: {
        alignSelf: 'center',
    },
    hide: {
        display: 'none',
    },
    select: __assign({}, theme.typography.body2),
    selectIcon: {
        color: theme.palette.primary.contrastText,
        top: theme.spacing(0.5),
    },
    labelDisplayedRows: {
        cursor: 'pointer',
    },
    pageSelectionPaper: {
        padding: theme.spacing(1),
    },
}); };
/** @deprecated Will be removed in a future major release */
var DeprecatedGridHeader = (0, styles_1.withStyles)(styles, { withTheme: true })(DataGridHeader);
exports.default = DeprecatedGridHeader;
//# sourceMappingURL=DataGridHeader.js.map